/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ErpstatuscodesQueryResponse } from '../../types/GetV1Erpstatuscodes.ts'

export const getV1ErpstatuscodesQueryKey = () => [{ url: '/v1/ErpStatusCodes' }] as const

export type GetV1ErpstatuscodesQueryKey = ReturnType<typeof getV1ErpstatuscodesQueryKey>

/**
 * {@link /v1/ErpStatusCodes}
 */
export async function getV1Erpstatuscodes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1ErpstatuscodesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/ErpStatusCodes`, ...requestConfig })
    return res
}

export function getV1ErpstatuscodesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ErpstatuscodesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ErpstatuscodesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ErpstatuscodesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Erpstatuscodes(config)
        },
    })
}

/**
 * {@link /v1/ErpStatusCodes}
 */
export function useGetV1Erpstatuscodes<
    TData = ResponseConfig<GetV1ErpstatuscodesQueryResponse>,
    TQueryData = ResponseConfig<GetV1ErpstatuscodesQueryResponse>,
    TQueryKey extends QueryKey = GetV1ErpstatuscodesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ErpstatuscodesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ErpstatuscodesQueryKey()

    const query = useQuery(
        {
            ...getV1ErpstatuscodesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
